export default {
    url: 'membership',
    include: ['de', 'fr', 'it', 'es', 'za', 'eu'],
};
